import moment from "moment";
// import momentDe from "moment/locale/de";
// console.log("momentDe", momentDe);
import "moment-timezone/moment-timezone.js";
import localeDe from "./locale/de";
localeDe(moment);
import localeEs from "./locale/de";
localeEs(moment);
import localeFr from "./locale/de";
localeFr(moment);
import localeId from "./locale/de";
localeId(moment);
import localeJa from "./locale/de";
localeJa(moment);
import localeNl from "./locale/de";
localeNl(moment);
import localeZhCn from "./locale/de";
localeZhCn(moment);
import localeZhHk from "./locale/de";
localeZhHk(moment);
import localeZhTw from "./locale/de";
localeZhTw(moment);

import _timezones from "./data.json";
moment.tz.load(_timezones);

export const timezones = {
    en: {
        tz: ["EST", "EDT"],
        lang: "en-US",
        city: "America/New_York"
    },
    fr: {
        tz: ["CEST"],
        lang: "fr-FR",
        city: "Europe/Paris"
    },
    de: {
        tz: ["CEST"],
        lang: "de-DE",
        city: "Europe/Berlin",
    },
    nl: {
        tz: ["CEST"],
        lang: "nl-NL",
        city: "Europe/Amsterdam"
    },
    es: {
        tz: ["CEST"],
        lang: "es-ES",
        city: "Europe/Madrid"
    },
    uk: {
        tz: ["GMT"],
        lang: "en-GB",
        city: "Europe/London"
    },
    au: {
        tz: ["AEST", "AEDT"],
        lang: "en-AU",
        city: "Australia/Melbourne" // "Australia/Sydney"
    },
    cn: {
        tz: ["CST"],
        lang: "zh-CH",
        city: "Asia/Shanghai"
    },
    hk: {
        tz: ["HKT"],
        lang: "zh-HK",
        city: "Asia/Hong_Kong"
    },
    id: {
        tz: ["WIB"],
        lang: "id-ID",
        city: "Asia/Jakarta"
    },
    jp: {
        tz: ["JST"],
        lang: "ja-JP",
        city: "Asia/Tokyo"
    },
    kr: {
        tz: ["KST"],
        lang: "kr-KR",
        city: "Asia/Seoul"
    },
    sg: {
        tz: ["SGT"],
        lang: "en-SG",
        city: "Asia/Singapore"
    },
    tw: {
        tz: ["CST"],
        lang: "zh-TW",
        city: "Asia/Taipei"
    },
    in: {
        tz: ["IST"],
        lang: "en-IN",
        city: "Asia/Kolkata"
    }
};

export function getTimeZone(locale) {
    return timezones[locale] || timezones.en;
}
// export const reg = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[\+\-]\d{4})\s(\w+(?:[+-]\d+)?)\s(\w+(?:\/\w+)?)$/i;
export const reg = /^([^\s]+)\s([^\s]+)\s([^\s]+)$/i;
export function parseISOTZ(datetimeString) {
    return ((!!datetimeString && reg.test(datetimeString)) ? datetimeString.match(reg) : undefined) ?? undefined;
}

export const parseISO8601 = (datetimeString, locale) => {
    if(!datetimeString)
        return null;
    const match = datetimeString.match(reg);
    if(!match)
        return null;
    const [, dtISO, tzShort, tzCity] = match;
    const currentTz = timezones[locale] || timezones.en;
    const city = timezones.en.tz.includes(tzShort) ? currentTz.city : tzCity;
    const lang = currentTz.lang;
    const datetime = moment(dtISO, moment.ISO_8601, true).tz(tzCity); // 先给一个时区，否则会转换为运行环境的时间
    if(tzCity !== city)
        datetime.tz(city, true);
    datetime.locale(lang);
    return datetime;
}

export default moment;